import React, { FC } from 'react'
import {
	useFileApi,
	useViewParams,
	UploadProps,
	useInitialValue,
	UploadContainer,
	File,
} from 'Modules'
import { BtnComponent } from 'LibNeo'
import { ACCEPTED_FILES, MAX_FILE_SIZE } from 'Constants/Global'

export const Upload: FC<UploadProps> = ({
	fieldName,
	disabled,
	fieldOptions,
	initialValue,
	multiple,
	form,
	actionCreate,
	actionUpdate,
	actionDelete,
	title = 'Загрузить файл',
	maxFileSize = MAX_FILE_SIZE,
	acceptedFiles = ACCEPTED_FILES,
	maxFilesCount = 1,
	hideDropzoneWhileMaxFiles,
	renderDropzone,
	renderFilePreview,
	hideFilePreview,
	hideDropzone,
	noAutoUpload,
	errorPlace,
	errorGap,
	customError,
	disableError,
	width,
}) => {
	const fileApiHelpers = useFileApi(fieldName)
	const { fileContainersList } = fileApiHelpers

	const viewParamsApi = useViewParams({
		title,
		maxFileSize,
		acceptedFiles,
		maxFilesCount,
	})

	useInitialValue({ fieldOptions, fieldName, initialValue, form, noAutoUpload })

	return (
		<UploadContainer
			{...fileApiHelpers}
			{...viewParamsApi}
			form={form}
			fieldName={fieldName}
			fieldOptions={fieldOptions}
			fileContainersList={fileContainersList}
			actionCreate={actionCreate}
			actionUpdate={actionUpdate}
			actionDelete={actionDelete}
			maxFileSize={maxFileSize}
			acceptedFiles={acceptedFiles}
			multiple={multiple}
			maxFilesCount={maxFilesCount}
			hideDropzoneWhileMaxFiles={hideDropzoneWhileMaxFiles}
			hideFilePreview={hideFilePreview}
			hideDropzone={hideDropzone}
			errorPlace={errorPlace}
			errorGap={errorGap}
			customError={customError}
			disableError={disableError}
			disabled={disabled}
			width={width}
			renderFilePreview={(props) =>
				renderFilePreview?.(props) || (
					<File
						file={props.file}
						status={props.status}
						deleteFile={props.deleteFile}
						description={props.description}
						showFilePreview={!noAutoUpload ? props.showFilePreview : undefined}
					/>
				)
			}
			renderDropzone={(props) =>
				renderDropzone?.(props) || (
					<BtnComponent
						icon={props.viewParams.viewIcon}
						title={props.viewParams.viewTitle}
						tooltip={props.viewParams.viewTooltip}
						disabled={disabled}
						outline
					/>
				)
			}
		/>
	)
}
